import { DEFAULT_REQUEST_METHOD } from './constants';
/**
 * Returns an id represent the request parameters.
 *
 * This is used to identify the request for caching and other purposes.
 */
export function apiRequestId(params) {
    return JSON.stringify([
        params.method || DEFAULT_REQUEST_METHOD,
        params.url,
        params.responseType || '',
        serializeHeaders(params.headers),
        params.extraKey,
        serializeSuccessCodes(params.successCodes)
    ]);
}
function serializeHeaders(paramHeaders) {
    if (!paramHeaders) {
        return '';
    }
    const headers = applyHeaders({}, paramHeaders);
    const headerPairs = [];
    for (const [key, value] of Object.entries(headers)) {
        headerPairs.push(`${key}:${value};`);
    }
    headerPairs.sort();
    return headerPairs.join('');
}
function serializeSuccessCodes(successCodes) {
    if (!successCodes) {
        return '';
    }
    const serializedCodes = uniqueCodes(successCodes.filter((code) => typeof code === 'number'));
    serializedCodes.sort();
    return JSON.stringify(serializedCodes);
}
function uniqueCodes(codes) {
    return codes.filter((value, index, self) => self.indexOf(value) === index);
}
/**
 * Given an origin ApiHeaders object and ApiHeaders object,
 * returns a new ApiHeaders object with the new headers applied.
 */
export function applyHeaders(prevHeaders, headers) {
    const nextHeaders = cloneHeaders(prevHeaders);
    for (const key of Object.keys(headers)) {
        nextHeaders[key.toLowerCase()] = headers[key];
    }
    return nextHeaders;
}
export function cloneHeaders(headers) {
    return Object.assign({}, headers);
}
//# sourceMappingURL=lib.js.map